import { render, staticRenderFns } from "./Voxuy.vue?vue&type=template&id=34a827ee&scoped=true&"
import script from "./Voxuy.vue?vue&type=script&lang=js&"
export * from "./Voxuy.vue?vue&type=script&lang=js&"
import style0 from "./Voxuy.vue?vue&type=style&index=0&id=34a827ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a827ee",
  null
  
)

export default component.exports